const getBaseURL = () => {
  if (typeof window === 'undefined') return 'http://clubvendemas.test';
  
  const { hostname, port, origin, pathname } = window.location;

  // Si se ejecuta desde un servidor de desarrollo local (localhost:3000, localhost:3001, etc.)
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    if (port && port !== '80' && port !== '443') {
      return 'http://localhost/clubvendemas';
    }
  }

  if (pathname.startsWith('/clubvendemas')) {
    return `${origin}/clubvendemas`;
  }

  return origin;
};

const baseURL = getBaseURL();
export default baseURL;
